export const AWS_LOCATION_BASE_URL = "https://places.geo.us-east-1.amazonaws.com/v2";
export const AWS_LOCATION_API_KEY = import.meta.env.VITE_AWS_LOCATION_API_KEY;
